"use client";

import SocialHeader from "@/views/social/components/header";
import InfoBlocks from "@/components/ui/info-blocks";
import { Socials } from "./constants/social";

const SocialView = () => {
  return (
    <div>
      <SocialHeader />
      <InfoBlocks blocks={Socials} />
    </div>
  );
};

export default SocialView;
